module.exports = __webpack_public_path__ + "static/media/realstate.a7742d45.svg";